<template>
  <v-dialog v-model="isOpen" scrollable max-width="1000px">
    <v-card>
      <v-card-title>
        <v-layout wrap>
          <v-flex sm3>
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3>
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.toDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.toDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3 v-if="showDateFilter">
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3 v-if="showDateFilter">
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.toDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.toDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              name="issueNo"
              label="Issue No"
              v-model="queryParams.issueNo"
              type="text"
              class="ml-2"
            ></v-text-field>
          </v-flex>
          <v-flex sm3 v-if="showShopFilter">
            <v-autocomplete
              label="Shop"
              :items="shopList"
              v-model="queryParams.shopId"
              item-text="name"
              item-value="id"
              color="blue-grey lighten-2"
              :hide-no-data="true"
              class="ml-2"
            ></v-autocomplete>
          </v-flex>
          <v-flex sm3 v-if="showDepartmentFilter">
            <v-autocomplete
              label="Department"
              :items="departmentList"
              v-model="queryParams.departmentId"
              item-text="name"
              item-value="id"
              color="blue-grey lighten-2"
              :hide-no-data="true"
              class="ml-2"
            ></v-autocomplete>
          </v-flex>
          <v-flex sm3 v-if="showStatusFilter">
            <v-select
              label="Status"
              :items="statusList"
              item-text="label"
              item-value="value"
              v-model="queryParams.status"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              name="serialNo"
              :label="queryParams.type == 'EMR' ? 'EMR No' : 'RMR No'"
              v-model="queryParams.serialNo"
              type="text"
              class="ml-2"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-btn outline color="primary" @click="onSearch">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex sm12 class="mt-1">
          <v-card>
            <v-data-table
              :headers="headers"
              :items="emrList"
              v-model="selectedEmrList"
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
            >
              <template slot="headers" slot-scope="props">
                <tr>
                  <th></th>
                  <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    primary
                    hide-details
                    :input-value="props.selected"
                    :value="props.item"
                    :indeterminate="props.indeterminate"
                    v-model="selectedEmrList"
                    multiple
                    :disabled="
                      !!selectedList &&
                      !!selectedList.find((v) => v.id == props.item.id)
                    "
                  ></v-checkbox>
                </td>
                <td>{{ props.item.issueNo }}</td>
                <td>
                  {{ props.item.issueDateInMilliSeconds | formatMsDate }}
                </td>
                <td>{{ props.item.serialNo }}</td>
                <td>{{ props.item.shopName }}</td>
                <td>{{ props.item.warehouseName }}</td>
                <td>{{ props.item.binName }}</td>
                <td>{{ props.item.departmentName }}</td>
                <td>{{ props.item.reason }}</td>
                <td>{{ props.item.status }}</td>
                <td>
                  {{
                    props.item.updatedDateInMilliSeconds
                      | format-ms-date-time
                  }}
                </td>
                <td>{{ props.item.updatedBy }}</td>
              </template>
            </v-data-table>
            <div class="text-xs-right">
              <v-btn color="primary" @click="dialogCloe()">OK</v-btn>
            </div>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { emrService } from "../../services/emr-service";
import { departmentService } from "../../services/department-service";
import { shopService } from "../../services/shop-service";
import { commonService } from "../../services/common-service";

export default {
  name: "MultiSelectEMRDialog",
  props: {
    showDialog: Boolean,
    params: Object,
    selectedList: Array,
  },
  data: () => ({
    showListLoading: false,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      departmentId: "",
      status: "",
      reason: "",
      isAddDetails: false,
      shopId: "",
      warehouseId: "",
      binId: "",
      stockWarehouseId: "",
      stockBinId: "",
      serialNo: "",
      binIds: [],
      type: "",
      isFinishedProduction: "",
    },
    headers: [
      { text: "Issue No", align: "left", value: "issueNo" },
      { text: "Issue Date", value: "issueDate" },
      { text: "Serial No", value: "serialNo" },
      { text: "Shop Name", value: "shop.name" },
      { text: "Warehouse Name", value: "warehouse.name" },
      { text: "Bin Name", value: "bin.name" },
      { text: "Department", value: "department.name" },
      { text: "Reason", value: "reason" },
      { text: "Status", sortable: false },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "UpdatedBy" },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    statusList: [
      { label: "---ALL---", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    totalRows: 0,
    rowsPerPageItems: [25, 50, 100],
    emrList: [],
    departmentList: [],
    shopList: [],
    selectedEmrList: [],
    showShopFilter: true,
    showDepartmentFilter: true,
    showStatusFilter: true,
    showDateFilter: true,
  }),
  created() {
    this.getActiveDepartments();
    this.getShopList();
    this.getEMRList();
  },
  computed: {
    isOpen: {
      get() {
        return this.showDialog;
      },
      set() {
        this.dialogCloe();
      },
    },
  },
  watch: {
    isOpen: {
      handler() {
        if (this.isOpen) {
          this.queryParams = { ...this.params };
          if (this.params) {
            this.showShopFilter = this.params.showShopFilter;
            this.showDepartmentFilter = this.params.showDepartmentFilter;
            this.showStatusFilter = this.params.showStatusFilter;
            this.showDateFilter = this.params.showDateFilter;
          }
          this.queryParams.fromDate = commonService.formatDate(
            new Date(),
            "YYYY-MM-DD"
          );
          this.queryParams.toDate = commonService.formatDate(
            new Date(),
            "YYYY-MM-DD"
          );
          this.emrList = [];
          this.selectedEmrList = [];
          this.getEMRList();
          this.changeSerialText();
        }
      },
    },
  },
  methods: {
    changeSerialText() { 
      this.headers[2].text = this.queryParams.type + " No";
    },
    getActiveDepartments() {
      departmentService
        .getDepartmentsByStatus("ACTIVE")
        .then((res) => {
          this.departmentList = res.data;
          let findAll = { id: "", name: "---All---" };
          this.departmentList.unshift(findAll);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getEMRList();
    },
    getEMRList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      emrService
        .getEMRList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.emrList = res.data.emrList;
            this.totalRows = res.data.totalElements;
            this.checkSelected(this.emrList);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    checkSelected(emrList) {
      if (this.selectedList.length > 0) {
        this.selectedEmrList = [];
        this.selectedList.forEach((emr) => {
          this.selectedEmrList.push(
            commonService.search("id", emr.id, emrList)
          );
        });
      } else {
        this.selectedEmrList = [];
      }
    },
    dialogCloe() {
      let newEMRList = [];
      this.selectedEmrList.forEach((v) => {
        let newEMR = commonService.search("id", v.id, this.selectedList);
        if (newEMR == undefined) {
          newEMRList.push(v);
        }
      });
      this.$emit("close", newEMRList);
    },
  },
};
</script>
